// project imports
import applications from './applications';
import widget from './widget';
import formsTables from './forms-tables';
import samplePage from './sample-page';
import chartsMap from './charts-map';
import other from './other';
import pages from './pages';
import newPages from './_new-pages';
import labAdminPages from './_labAdmin-pages';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [labAdminPages, newPages]
  // items: [labAdminPages, newPages, widget, applications, formsTables, chartsMap, samplePage, pages, other]
};

export default menuItems;
